export default "__VITE_ASSET__0c41cbb8__"